import React from "react";
import { Link, useRouter } from "../router";
import { useAuth } from "../auth-context";

export default function NavBar() {
  const { user, logout } = useAuth();
  const { navigate } = useRouter();

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          Inside <span>LMS</span>
        </Link>
        <nav className="navbar-links">
          <Link to="/">Courses</Link>
          <Link to="/contact">Contact</Link>
          {user && <Link to="/dashboard">My Learning</Link>}
          {user && user.role === "admin" && <Link to="/admin">Admin</Link>}
          {user && <Link to="/account">Account</Link>}
          {user ? (
            <button
              className="btn btn-ghost"
              onClick={async () => {
                await logout();
                navigate("/");
              }}
            >
              Log out ({user.name})
            </button>
          ) : (
            <>
              <Link to="/login">Log in</Link>
              <Link to="/register" className="btn btn-primary btn-sm">
                Sign up
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
